export const CHECKOUT_STEP_SHIPPING = 'shipping'
export const CHECKOUT_STEP_BILLING = 'billing'
export const CHECKOUT_STEP_PAYMENT = 'payment'
